import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Immediately scroll to top when route changes
    const scrollableContent = document.querySelector('.scrollable-content');
    if (scrollableContent) {
      scrollableContent.scrollTop = 0;
    }
    // Also scroll window as fallback
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
